import rightPanel from "./rightPanel.jsx";

export default function (editor, opts = {}) {

  const em = editor.getModel();

  const module = new rightPanel(editor, opts);

  em.get("modules").push(module);
  console.log(em.get("modules"))
  if (module.onLoad) em.get("toLoad").push(module);
}
